// extracted by mini-css-extract-plugin
module.exports = {"form":"_1EPxEV0j","submit":"_1_RtzsxQ"};